import type { ChangeEvent, FocusEvent } from "react";
import type { UseFormRegisterReturn } from "react-hook-form";
import type { TextInputEvent } from "src/components/TextInput";

// TextInput / PasswordInput expose `onChange?: (val, event) => void` and don't
// pipe `onBlur` to the underlying input. react-hook-form v7 ships
// `register("name")` with React-style `onChange(event)` / `onBlur(event)`.
// This adapter bridges the two so RHF tracks value/touched state correctly
// while still surfacing the parent-friendly `(val, event)` callback.
export const registerCustomInput = (
  reg: UseFormRegisterReturn,
  onChange?: (val: string, event: TextInputEvent) => void
): {
  name: string;
  ref: UseFormRegisterReturn["ref"];
  onChange: (val: string, event: TextInputEvent) => void;
  onBlur: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
} => ({
  name: reg.name,
  ref: reg.ref,
  onChange: (val, event) => {
    reg.onChange(event as unknown as ChangeEvent<HTMLInputElement>);
    onChange?.(val, event);
  },
  onBlur: (event) => {
    reg.onBlur(event as unknown as FocusEvent<HTMLInputElement>);
  },
});
